/**
 * Team Member Enums
 *
 * Enums for business portal team management.
 * Issue #313 - Centralize enums to shared-types
 */

import { z } from 'zod';

// ============================================================================
// BUSINESS TEAM ROLE
// ============================================================================

/**
 * Business portal team member roles
 * Different from admin portal PortalRole
 */
export enum BusinessTeamRole {
  ADMIN = 'admin',
  MANAGER = 'manager',
  MEMBER = 'member',
  VIEWER = 'viewer',
}

/** Zod schema for BusinessTeamRole validation */
export const BusinessTeamRoleSchema = z.nativeEnum(BusinessTeamRole);

/** Array of all business team roles for iteration */
export const BUSINESS_TEAM_ROLES = Object.values(BusinessTeamRole);

// ============================================================================
// BUSINESS TEAM STATUS
// ============================================================================

/**
 * Business portal team member status
 */
export enum BusinessTeamStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'inactive',
}

/** Zod schema for BusinessTeamStatus validation */
export const BusinessTeamStatusSchema = z.nativeEnum(BusinessTeamStatus);

/** Array of all business team statuses for iteration */
export const BUSINESS_TEAM_STATUSES = Object.values(BusinessTeamStatus);

// ============================================================================
// INVITE EMAIL CHECK STATUS (Issue #703)
// ============================================================================

/**
 * Result status for checking an email before sending a team invite.
 * Used by the checkInviteEmail tRPC route and InviteTeamDrawer UI.
 */
export enum InviteEmailCheckStatus {
  /** Email is not on the platform — safe to invite */
  AVAILABLE = 'available',
  /** Email belongs to an existing member of the current business */
  ALREADY_MEMBER = 'already_member',
  /** Email exists on the platform but in a different organization */
  EXISTS_ELSEWHERE = 'exists_elsewhere',
}

/** Zod schema for InviteEmailCheckStatus validation */
export const InviteEmailCheckStatusSchema = z.nativeEnum(InviteEmailCheckStatus);
